import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useCompany } from "../context/CompanyContext";
import axiosInstance from "../utils/axiosInstance";

export const useFetchCompany = () => {
  const { setCompany, setCompanies, setCompaniesLoading } = useCompany();
  // The company list needs a signed-in user, so fetch it after login.
  const isAuthenticated = useSelector((state) => state.auth?.isAuthenticated);

  useEffect(() => {
    if (!isAuthenticated) {
      setCompaniesLoading(false);
      return;
    }
    const fetchCompanies = async () => {
      try {
        const response = await axiosInstance.get("/accounts/company-options/", {
          skipCompany: true,
        });
        const companyList = Array.isArray(response.data)
          ? response.data
          : response.data.results || [];
        setCompanies(companyList);

        const storedId = localStorage.getItem("active_company_id");
        const selected =
          companyList.find((item) => String(item.id) === String(storedId)) ||
          companyList[0] ||
          null;
        setCompany(selected);
      } catch (error) {
        console.error("Failed to fetch companies:", error);
      } finally {
        setCompaniesLoading(false);
      }
    };

    fetchCompanies();
    // Context setters are stable for the lifetime of the provider.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);
};
